const globalStyles = {
  a: {
    textDecoration: 'none',
    color: 'inherit',
    fontWeight: 800
  }
};

export default globalStyles;
